import { Card, Space, Typography, Statistic, theme } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import { CSSProperties } from 'react';

const { Text } = Typography;

export interface KpiCardProps {
  title: string;
  value: number | string;
  suffix?: string;
  prefix?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  color?: string;
  onClick?: () => void;
  loading?: boolean;
}

export function KpiCard({
  title,
  value,
  suffix,
  prefix,
  trend,
  color,
  onClick,
  loading,
}: KpiCardProps) {
  const { token } = theme.useToken();
  const effectiveColor = color || token.colorPrimary;

  const cardStyle: CSSProperties = {
    cursor: onClick ? 'pointer' : 'default',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    borderTop: `3px solid ${effectiveColor}`,
    borderRight: 'none',
    borderBottom: 'none',
    borderLeft: 'none',
    background: 'transparent',
    boxShadow: 'none',
  };

  return (
    <Card
      style={cardStyle}
      styles={{ body: { padding: '10px 12px' } }}
      onClick={onClick}
      loading={loading}
      hoverable={false}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.background = token.colorFillTertiary;
          e.currentTarget.style.boxShadow = token.boxShadow;
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = '';
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
    >
      <Space direction="vertical" size={2} style={{ width: '100%' }}>
        <Text type="secondary" style={{ fontSize: '11px', fontWeight: 500 }}>
          {title}
        </Text>
        <div>
          <Statistic
            value={value}
            suffix={suffix}
            prefix={prefix}
            valueStyle={{ color: effectiveColor, fontSize: '20px', fontWeight: 'bold', lineHeight: 1.2 }}
          />
        </div>
        {trend && (
          <Space size="small">
            {trend.isPositive ? (
              <ArrowUpOutlined style={{ color: token.colorSuccess, fontSize: '10px' }} />
            ) : (
              <ArrowDownOutlined style={{ color: token.colorError, fontSize: '10px' }} />
            )}
            <Text
              style={{
                color: trend.isPositive ? token.colorSuccess : token.colorError,
                fontSize: '10px',
              }}
            >
              {trend.isPositive ? '+' : ''}
              {trend.value}% 前月比
            </Text>
          </Space>
        )}
      </Space>
    </Card>
  );
}
